// @flow

import skrollTop from "skrolltop";

const keys = [37, 38, 39, 40];

const eventsToPreventDefault = ["onwheel", "onmousewheel", "ontouchmove"];

const preventDefault = (e = window.event) => {
  if (e.preventDefault) {
    e.preventDefault();
  }
  e.returnValue = false;
};

const preventDefaultForScrollKeys = e => {
  const { keyCode } = e;

  if (keys.includes[keyCode]) {
    preventDefault(e);
    return false;
  }

  return true;
};

export const disableScroll = () => {
  if (window.addEventListener) {
    // older FF
    window.addEventListener("DOMMouseScroll", preventDefault, false);
  }

  eventsToPreventDefault.forEach(eventName => {
    window[eventName] = preventDefault;
  });

  window.onkeydown = preventDefaultForScrollKeys;
};

export const enableScroll = () => {
  if (window.removeEventListener) {
    window.removeEventListener("DOMMouseScroll", preventDefault, false);
  }

  eventsToPreventDefault.forEach(eventName => {
    window[eventName] = null;
  });

  window.onkeydown = null;
};

export const scrollTop = () => {
  disableScroll();

  skrollTop.scrollTo({
    to: 0,
    callback: () => {
      enableScroll();
    }
  });
};
